module.exports = __webpack_public_path__ + "static/img/101160.5b5b4bd9.png";